import {
  Link,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  MessageBarTitle,
} from '@fluentui/react-components';
import { ExternalLink } from 'lucide-react';

import { ConsentErrorData } from '../../types/identity';

// Actionable rendering of a consent-class 409 (FD-096 shape: TENANT_NOT_CONSENTED /
// TENANT_CONSENT_DRIFT). Names the tenant, lists the missing Graph roles, and
// links the admin-consent URL. Raw error strings are never shown for
// consent-class failures (FD-098 acceptance criterion).
export default function ConsentMessageBar({ consent }: { consent: ConsentErrorData }) {
  return (
    <MessageBar intent="warning">
      <MessageBarBody>
        <MessageBarTitle>Tenant consent required</MessageBarTitle>
        Tenant <span className="font-mono text-xs">{consent.tenantId}</span> has not
        consented the required Graph permissions
        {consent.missingRoles.length > 0 && (
          <>
            {' '}
            (missing:{' '}
            <span className="font-mono text-xs">{consent.missingRoles.join(', ')}</span>)
          </>
        )}
        . An admin of that tenant must grant consent before identity operations can run.
      </MessageBarBody>
      <MessageBarActions>
        <Link href={consent.consentUrl} target="_blank" rel="noreferrer">
          <span className="inline-flex items-center gap-1">
            Grant consent
            <ExternalLink size={12} strokeWidth={1.5} />
          </span>
        </Link>
      </MessageBarActions>
    </MessageBar>
  );
}
